import React from 'react';
import IconBase, { iconPropTypes } from '../IconBase';

export default function SinglePlyRoofIcon(props) {
	return (
		<IconBase type="single-ply-roof" {...props}>
			<path d="M13.6228 20.5H21V4.5H14V19.5C14 19.916 13.8326 20.2475 13.6228 20.5Z" />
			<path d="M13 4.5C13 3.67157 10.7614 3 8 3C5.23858 3 3 3.67157 3 4.5V19.5C3 20.3284 5.23858 21 8 21C9.38071 21 10.6307 20.8321 11.5355 20.5607C11.6011 20.541 11.6649 20.5207 11.7268 20.5C12.5186 20.2346 13 19.8842 13 19.5V4.5ZM11 19.5C11 19.7761 9.65685 20 8 20C6.34315 20 5 19.7761 5 19.5C5 19.2239 6.34315 19 8 19C9.65685 19 11 19.2239 11 19.5Z" />
		</IconBase>
	);
}
SinglePlyRoofIcon.propTypes = iconPropTypes;
